var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 14,
  height: 20,
  viewBox: "0 0 14 20"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-717 -365)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.581,1,13.953,5.892H10.789L8,1Z",
  transform: "translate(711.709 364)",
  fill: "#d8d8d8"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.1,8.746,8.336,10a7.275,7.275,0,0,0-3.624,1.325L1.47,5.917a.819.819,0,0,1,.008-.856L4.063,1l3.18,4.892Z",
  transform: "translate(715.646 364)",
  fill: "#e3e3e3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M26.585,5.917l-3.241,5.406A7.3,7.3,0,0,0,19.1,9.969c-.208,0-.416.008-.62.029l.762-1.252L21,5.892l3-4.892,2.585,4.061A.819.819,0,0,1,26.585,5.917Z",
  transform: "translate(704.298 364)",
  fill: "#e3e3e3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.473,30.339a7.078,7.078,0,0,1-6.545,7.338A7,7,0,0,1,2.01,30.755a7.161,7.161,0,0,1,6.157-7.726A5.267,5.267,0,0,1,8.736,23c3.72,0,6.735,3.286,6.736,7.338Z",
  transform: "translate(715.264 347.321)",
  fill: "#d8d8d8"
}))));
export default __webpack_public_path__ + "static/media/bestseller-disable.18706fc0.svg";
export { SvgComponent as ReactComponent };